import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from '../routing/navigator';
import { EventsService } from '../event/event.service';

declare var window: any;

@Injectable({
  providedIn: 'root'
})

export class DepositButtonService {

  private defaultDepositPage: string = 'DepositMainComponent';
  private iosOnlyPaymentTypes = ["VVAP"];
  defaultIsTrue = item => item.is_default == true;

  constructor(
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public navigator: Navigator,
    public utilsService: UtilsService,
    public userSession: UserSessionService,
    private platform: Platform,
    private events: EventsService,
  ) {
  }

  public onDeposit(campaignId?, type?: string, depositMethod?: string, navigateBackPage?: string) {
    this.cashierService.getActiveTypesCategories({ include_types: false }).subscribe({
      next: (response: any) => {
        let pageToRedirect = this.defaultDepositPage;
        if (response) {
          const data = response.payload.filter(this.defaultIsTrue);
          let lastDeposit = data.length > 0 ? data[0].code : null;
          //Apple Pay is only supported on iOS app
          if (this.iosOnlyPaymentTypes.includes(lastDeposit) && !(this.platform.is('capacitor') && this.platform.is('ios'))) {
            lastDeposit = null;
          }
          const getPage = depositMethod ?? lastDeposit;
          pageToRedirect = this.cashierContentService.getVendorPage(getPage);
          window._window_has_closed = true;
        }

        return this.redirect(pageToRedirect, campaignId, type, depositMethod, navigateBackPage);
      },
      error: () => { window._window_has_closed = true; }
    });
  }

  private redirect(pageToRedirect: string, campaignId?, type?: string, depositMethod?: string, navigateBackPage?: string) {
    this.utilsService.setCampaignId(campaignId);

    const navParams: any = {};

    if (!!depositMethod) navParams.depositMethod = depositMethod;
    if (!!navigateBackPage) {
      navParams.navigateBackPage = navigateBackPage;
    }
    else if (type === 'sidemenu' || type === 'navbar-text' || type === 'navbar' || type === 'banner') {
      navParams.navigateBackPage = type
    }
    else {
      navParams.navigateBackPage = "default";
    }

    const recievedSelectedBonus = this.cashierContentService.getSelectedBonus();
    if (!!campaignId) {
      this.cashierContentService.setSelectBestOne(false)
      navParams.bonusCode = campaignId;
    } else {
      if (recievedSelectedBonus) {
        this.cashierContentService.setSelectBestOne(true);
        navParams.bonusCode = recievedSelectedBonus.offer.campaign_code;
      }
    }
    this.navigator.navigateTo(pageToRedirect, { multipleModals: true }, navParams);
    if (recievedSelectedBonus) {
      this.cashierContentService.setSelectedBonus(recievedSelectedBonus);
    }
  }

  public onPromoDeposit(deposit_data, isUserLoggedIn, navigateBackPage?): any {
    if (!isUserLoggedIn) {
      this.events.subscribe("event:login", (data) => {
        if (data) {
          this.setCampaignOffer(deposit_data);
          this.onDeposit(deposit_data?.id, 'banner', undefined, navigateBackPage);
        }
      });
      this.navigator.navigateTo("LoginComponent");
    } else {
      this.setCampaignOffer(deposit_data);
      this.onDeposit(deposit_data?.id, 'banner', undefined, navigateBackPage);

    }
  }

  private setCampaignOffer(data) {
    this.cashierContentService.updateBonusOfferValue(data?.campaign_code);
    this.events.publish("event:BonusOffer", {
      bonusOffer: data,
      actionType: "clickthrough",
    });
  }
}
